import { grey, yellow, orange, red, green, purple } from "@mui/material/colors";

/**
 * Maps Linear issue status to pale MUI colors for tag styling
 * @param status - The Linear issue status name (case-insensitive)
 * @returns A pale MUI color string suitable for tag backgrounds
 */
export function getLinearStatusColor(status: string): string {
  const statusLower = status.toLowerCase().trim();

  // Gray: default, backlog, or todo
  if (
    statusLower === "default" ||
    statusLower === "backlog" ||
    statusLower === "todo" ||
    statusLower === "to do"
  ) {
    return grey[300];
  }

  // Yellow: in progress
  if (statusLower === "in progress" || statusLower === "inprogress") {
    return yellow[100];
  }

  // Orange: code review
  if (statusLower === "code review" || statusLower === "codereview" || statusLower === "review") {
    return orange[100];
  }

  // Red: blocked or triage
  if (statusLower === "blocked" || statusLower === "triage") {
    return red[100];
  }

  // Green: final review or done
  if (
    statusLower === "final review" ||
    statusLower === "finalreview" ||
    statusLower === "done" ||
    statusLower === "completed"
  ) {
    return green[100];
  }

  // Pale purple: cancelled or won't do
  if (
    statusLower === "cancelled" ||
    statusLower === "canceled" ||
    statusLower === "won't do" ||
    statusLower === "wont do" ||
    statusLower === "won'tdo"
  ) {
    return purple[100];
  }

  // Default fallback to gray
  return grey[300];
}
